/**
 * EnvVars to configs mapping.
 *
 * We consider that all env vars are strings.
 *
 * Because when an inexistent EnvVar is referenced,
 * it will be a `{}.INEXISTENT_VAR` reference instead of a literal `undefined` in the built code,
 * so we always use `String(... ?? '')` to convert env vars to string.
 */

// please keep env vars in alphabetical order

// There is an unknown issue with the Vite Build mode that
// we can't put the ` === 'true'` check directly with the `import.meta.env.XYZ` expression.
// Otherwise, the variable value will be ignored in the production build.
// So we use a separate variable to hold the value and then check it.
const VITE_ALLOW_FEATURE_FLAGS = String(import.meta.env.VITE_ALLOW_FEATURE_FLAGS ?? '');
// Whether the FE development Feature flags are allowed.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ALLOW_FEATURE_FLAGS = VITE_ALLOW_FEATURE_FLAGS === 'true';
// Identity API URL.
export const API_BASE_URL = String(import.meta.env.VITE_API_BASE_URL ?? '');
// URL for the background image on the login/logout pages.
export const AUTH_BACKGROUND_IMAGE_URL = String(import.meta.env.VITE_AUTH_BACKGROUND_IMAGE_URL ?? '');
// Chameleon API key.
export const CHAMELEON_API_KEY = String(import.meta.env.VITE_CHAMELEON_API_KEY ?? '');
// OAuth2 client ID.
export const CLIENT_ID = String(import.meta.env.VITE_CLIENT_ID ?? '');
// The subpath to the static CMS data in the `public/cms/*` folder.
export const CMS_PATH = String(import.meta.env.VITE_CMS_PATH ?? '');
// URL For the default project tile image.
export const DEFAULT_TILE_IMAGE = String(import.meta.env.VITE_DEFAULT_TILE_IMAGE ?? '');
// Google tag manager ID.
export const GTM_ID = String(import.meta.env.VITE_GTM_ID ?? '');
// Sentry DSN.
export const SENTRY_DSN = String(import.meta.env.VITE_SENTRY_DSN ?? '');

// please keep env vars in alphabetical order
